<template>
  <div class="pb-input-block">
    <div v-if="subTitle" class="pb-input-sub-title">
      {{ subTitle }}
    </div>
    <div :class="{ 'pb-input-core': true, [size]: true }">
      <slot name="instead">
        <input
          v-model="_value"
          :class="{ selector }"
          :type="type"
          :id="id"
          :placeholder="placeholder"
          :readonly="readOnly"
          :disabled="disabled"
          :accept="accept"
          @change="$emit('change')"
          @keyup="keyupHandler"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
        />
      </slot>

      <div class="pb-input-select-icon" v-if="selector">
        <i class="fas fa-angle-down"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PbInput",
  props: {
    type: {
      type: String,
      default: () => "text",
    },
    value: {
      type: String,
      default: () => "",
    },
    size: {
      type: String, // "small" | "default" | "large"
      default: () => "default",
    },
    placeholder: String,
    id: String,
    name: String,
    readOnly: Boolean,
    subTitle: String,
    accept: String,
    selector: Boolean,
    disabled: Boolean,
  },
  computed: {
    _value: {
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    keyupHandler(ev) {
      this.$emit("keyup");

      if (ev.keyCode === 13) {
        this.$emit("enter");
      }
    },
  },
};
</script>
<style lang="scss">
@import "~styles/color";

.pb-input-sub-title {
  color: #656565;
  font-size: 11px;
  padding: 0.6rem 0.5rem;
  display: inline-block;
}

.pb-input-core {
  position: relative;

  &.small input {
    height: 46px;
    padding: 0 1.4rem;
    font-size: 1.35rem;
  }

  &.default input {
    padding: 1.5rem 1.4rem;
    font-size: 1.5rem;
  }
}

.pb-input-select-icon {
  position: absolute;
  width: 42px;
  right: 0;
  top: 0;
  text-align: center;
  font-size: 2rem;
  transform: translateY(50%);

  i {
    transition: all 0.25s;
  }
}

.pb-input-block {
  display: inline-block;
  width: 100%;

  input {
    width: 100%;
    border-radius: 5px;
    border: 1px solid #ececec;
    transition: all 0.25s;

    &:focus {
      & + div > i {
        color: $primary;
      }
    }

    &:disabled {
      color: #797979;
      background-color: #ececec;
      border-color: transparent;
      cursor: not-allowed;

      & + div > i {
        color: #797979;
      }
    }

    &.selector {
      padding-right: 42px;
    }
  }
}
</style>
